import React from 'react';
import Brand from './Brand.jsx';
import BackLink from './BackLink.jsx';
import ProfileMenu from './ProfileMenu.jsx';
import MobileReminder from './MobileReminder.jsx';
import ViewingAsBanner from './ViewingAsBanner.jsx';

// Shared sticky page header — the SINGLE source of truth for the top chrome across
// every page: logo + optional back link + the profile menu, plus two page-specific
// slots. Change the logo, spacing, stickiness, etc. here and it updates everywhere.
//
// Layout:  [ back? ] [ Brand ] [ center ]  …spacer…  [ right ] [ ProfileMenu ]
//          [ "Add your mobile number" reminder, when it applies (MobileReminder.jsx) ]
//
// Slots (the React analog of Rails yield/content_for) let a page inject its own bits:
//   center — rendered right after the logo (e.g. Layouts' ticker chips, the dashboard's
//            market-status + discipline chips)
//   right  — rendered just before the profile menu (e.g. the dashboard's "Brokers Hub"
//            button, Daily Analysis' "Manage Checklist" link)
// The page keeps its own state/handlers and passes finished JSX into a slot.
//
// Props:
//   user    — current user (forwarded to ProfileMenu)
//   active  — menu item to highlight (forwarded to ProfileMenu)
//   back    — { href, label } to show a "← label" BackLink; omit on the home page
//   center  — optional JSX slot after the logo
//   right   — optional JSX slot before the profile menu
const headerStyle = {
  display: 'flex', alignItems: 'center', gap: 14, padding: '14px 24px',
  borderBottom: '1px solid var(--border)', background: 'var(--surface)',
  position: 'sticky', top: 0, zIndex: 100, flexWrap: 'wrap',
};

export default function AppHeader({ user, active, back = null, center = null, right = null }) {
  return (
    <>
      {/* Above the header, not inside it: whose account this is must be the first thing on the page. */}
      <ViewingAsBanner user={user} />
      <header style={headerStyle}>
        {back && <BackLink href={back.href}>{back.label}</BackLink>}
        <Brand />
        {center}
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 12 }}>
          {right}
          <ProfileMenu active={active} user={user} />
        </div>
      </header>
      <MobileReminder user={user} active={active} />
    </>
  );
}
